import { Menu, Menus } from '../interfaces/menu.interface';

export const MENUS: Menus = {
  BUYER: [
    {
      title: 'Início',
      icon: 'dashboard',
      route: '/comprador/inicio',
    },
    {
      title: 'Operações',
      icon: 'shopping_cart',
      route: '/comprador/operacoes',
    },
    {
      title: 'Financeiro',
      icon: 'attach_money',
      route: '/comprador/financeiro',
    },
  ],
  LEAD: [
    {
      title: 'Início',
      icon: 'dashboard',
      route: '/cedente/inicio',
    },
    {
      title: 'Operações',
      icon: 'shopping_cart',
      route: '/cedente/operacoes',
    },
  ],
};
